import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuadroSaudeComponent } from './quadro-saude.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: QuadroSaudeComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuadroSaudeRoutingModule { }
